import productService from '../../../../../services/products';
import constants from '../../../../../settings/constants';
import tacHelpers from '../../../tacHelpers';
import validationErrors from '../validationErrors';
import * as Sentry from '@sentry/browser';

function tooCloseToSibling(section, allSections) {
  return allSections.some(
    otherSection =>
      otherSection.itemid !== section.itemid &&
      otherSection.x - (section.x + section.width) <
        constants.SECTION_SNAPPING_DISTANCE &&
      otherSection.x - (section.x + section.width) >= 0
  );
}

function validate(tac) {
  const allSections = tac.items.filter(productService.isSection);

  return tac.items.reduce((errors, item) => {
    if (productService.isSection(item)) {
      if (tooCloseToSibling(item, allSections)) {
        const sidePanelId = item.items.find(
          child => productService.isType(child, 'side-panel') && child.x > 0
        ).itemid;

        errors.push({
          ...validationErrors.DUPLICATE_SIDEPANELS,
          itemid: sidePanelId,
        });
      }
    } else if (productService.isType(item, 'mounting-rail')) {
      if (!tacHelpers.isWithinWall(item, tac)) {
        Sentry.captureMessage('AURDAL_SUSPENSION_RAIL_TOO_WIDE');
        errors.push({
          ...validationErrors.SUSPENSION_RAIL_TOO_WIDE,
          itemid: item.itemid,
        });
      }
    }
    return errors;
  }, []);
}

export default { validate };
